import { render, staticRenderFns } from "./px-information-card-collapsible.vue?vue&type=template&id=47b4d8c2&scoped=true&"
import script from "./px-information-card-collapsible.vue?vue&type=script&lang=ts&"
export * from "./px-information-card-collapsible.vue?vue&type=script&lang=ts&"
import style0 from "./px-information-card-collapsible.vue?vue&type=style&index=0&id=47b4d8c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b4d8c2",
  null
  
)

export default component.exports